'use strict';
(function($){
	/*
	 * Vetology.ImageHandler widget
	 *
	 * @description This is the main ImageHandler widget that supports managing images through file inputs and other methods.
	 *
	 * @options					See description for each option
	 *
	 * @method	See description above each method
	 */
	$.widget(
		'Vetology.ImageHandler',
		{
			"options": {
			},
			/*
			 * Vetology.ImageHandler._init
			 *
			 * @description	Initializes the Vetology.ImageHandler
			 *
			 * @return NULL
			 *
			 */
			"_init": function(){
				var o = this;
				o._enableEvents();
			},
			/*
			 * Vetology.ImageHandler._enableEvents
			 *
			 * @description	Adds events to the body so it handles dripping of images in supported placeholders
			 *
			 * @return NULL
			 *
			 */
			"_enableEvents": function(){
				var o = this;
				var fileAPI = !!('File' in window &&
								  'FileReader' in window &&
								  'FileList' in window &&
								  'Blob' in window);
				if(fileAPI){
					$("body").on("click", ".imageHandler .inputHandler", function(e){
						var el = $(this);
						el.closest(".imageHandler").find("input").click();
					});
					$(document).off('dragover', ".imageHandler");
					$(document).off('dragleave', ".imageHandler");
					$(document).off('drop', ".imageHandler");
					$("body").on('dragover', ".imageHandler", function(e){
						e.preventDefault();
						var el = $(this);
						var dt = e.originalEvent.dataTransfer;
						if(dt.types != null && (
								dt.types.indexOf ? dt.types.indexOf('Files') != -1 : 
								(dt.types.contains('application/x-moz-file') ||
									(typeof dt.types[0] != 'undefined' && dt.types[0].indexOf('Files') != -1))
							)
						){
							el.addClass('docs_detected');
						} else {
							el.removeClass('docs_detected');
						}
					});
					$("body").on('dragleave', ".imageHandler", function(e) {
						var el = $(this);
						el.removeClass('docs_detected');
					});
					$("body").on('drop', ".imageHandler", function(e) {
						e.preventDefault();
						var dt = e.originalEvent.dataTransfer;
						var el = $(this);
						el.removeClass('docs_detected');
						if(
							dt.types != null && 
								(
									dt.types.indexOf ? dt.types.indexOf('Files') != -1 : 
									(
										dt.types.contains('application/x-moz-file')
										||
										(
											typeof dt.types[0] != 'undefined' && dt.types[0].indexOf('Files') != -1
										)
									)
								)
						){
							o._processImage(e.originalEvent.dataTransfer.files, el);
						}
					});
					$("body").on('change', '.imageHandler input[type="file"]', function(e){
						o._processImage(e.target.files, $(this).closest(".imageHandler"));
					});
				}
			},
			/*
			 * Vetology.ImageHandler._processImage
			 *
			 * @description	Processes an image an the callback feature
			 *
			 * @return NULL
			 *
			 */
			"_processImage": function(files, el){
				var o = this;
				var file = files[0];
				if(file.type.match('image.*')){
					var reader  = new FileReader();
					var img  = el.find("img");
					var base64  = el.find(".base64");
					var base64Boolean  = el.find(".base64Boolean");
					reader.addEventListener("load", function(){
						var imagePNG = URL.createObjectURL(file);
						var tmpImg = new Image();
						tmpImg.onload = function() {
							var canvas = document.createElement("canvas");
							canvas.width = tmpImg.width;
							canvas.height = tmpImg.height;
							canvas.getContext("2d").drawImage(tmpImg, 0, 0);
							var src = canvas.toDataURL("image/png");
							img.attr("src", src);
							base64Boolean.val(1);
							base64.val(src);				
						}
						tmpImg.src = imagePNG;
					}, false);
					if(file){
						reader.readAsDataURL(file);
					}
				} else {
					$("body").Vetology("vetologyShowDialog", "Error", "You can only use images here", "error");
				}
			}
		}
	);
})(jQuery);